/**
 * 故障分析报表接口
 */

const prefix = '/dseWeb'
export default [
  // 统计
  { name: 'getMonthAnalyzeCount', url: `${prefix}/v1/op/monthAnalyze/count`, method: 'post' },

  // 故障详情分页查询
  { name: 'getMonthAnalyzePage', url: `${prefix}/v1/op/monthAnalyze/page`, method: 'post' }
]
